import Vue from 'vue'
import $api from '@/shared/services/api'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

const TOKEN_ID = 'x-token-auth'
export default {
    namespaced: true,
    state: {
        token_agenda: Vue.$cookies.get(TOKEN_ID),
        usuarioLogado: null,
        modalLogin: false,
    },
    getters: {
        pegaUsuarioLogado(state){
            return state.usuarioLogado
        },
        pegaToken(state){
            return state.token_agenda
        },
        pegaModalLogin(state){
            return state.modalLogin
        },
    },
    mutations: {
        atualizaToken(state, token_agenda){
            state.token_agenda = token_agenda
        },
        atualizaUsuarioLogado(state, usuarioLogado){
            state.usuarioLogado = usuarioLogado
        },
        atualizaModalLogin(state, modalLogin){
            state.modalLogin = modalLogin
        }
    },
    actions: {
        salvaToken({ commit }, data){
            Vue.$cookies.set(TOKEN_ID, data.token_agenda, null, null, data.url_token || null)
            commit('atualizaToken', data.token_agenda)
        },
        async login({ dispatch }, dados = []){
            const login = await $api.cPost('/agenda_pro/meus_agendamentos/login', dados)
            if(login.status == 'success'){
                dispatch('salvaToken', login.data)
            }
            return login
        },
        async logout({ commit, dispatch }){
            const logout = await $api.cGet('/agenda_pro/meus_agendamentos/deslogar')
            if(logout.status == 'success'){
                dispatch('salvaToken', logout.data)
                commit('usuarioLogado', [])
            }
            return logout
        },
        async carregaUsuarioLogado({ commit }){
            const autenticacao = await $api.cGet(
                '/agenda_pro/meus_agendamentos/verifica_autenticacao', 
                {}, 
                false
            )
            if(autenticacao.status == 'success'){
                commit('atualizaUsuarioLogado', autenticacao.data)
            }
            return autenticacao
        }, 
    },
}
